var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.809 25.697c-.244.141-.576.294-.809.294-.233 0-.565-.153-.797-.294C8.955 21.777 5 17.215 5 12.577 5 8.721 7.692 6 11.17 6c2.16 0 3.844 1.187 4.83 2.972C17.008 7.176 18.67 6 20.83 6 24.308 6 27 8.722 27 12.577c0 4.638-3.955 9.2-10.191 13.12zm-3.492-8.822a.31.31 0 0 1-.317-.313c0-.101.038-.192.115-.293l3.84-5.082c.298-.384.778-.132.605.353l-1.267 3.577h2.38c.173 0 .327.142.327.323a.49.49 0 0 1-.125.294l-3.84 5.081c-.288.384-.778.122-.605-.353l1.268-3.587z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBolt);
export default __webpack_public_path__ + "static/media/Heart_Bolt.de40f1f01e98983400c5e33fb3edbf95.svg";
export { ForwardRef as ReactComponent };